import React from 'react';
import TextComponent, {
  TextProps,
  TextFieldGlimmer as TextFieldGlimmerComponent,
} from '../../components/fields/text/Text';
import '../../../../stylesheets/components/textField.module.scss';
import editStyles from '../../../../stylesheets/components/edit.module.scss';
import glimmerStyles from '../../../../stylesheets/components/glimmer.module.scss';
import classNames from 'classnames';

const Text = ({
  field,
  mode,
  onChange,
  onKeyDown,
  testClass,
  errors,
}: TextProps) => {
  return (
    <TextComponent
      field={field}
      mode={mode}
      variant="outlined"
      onChange={onChange}
      onKeyDown={onKeyDown}
      editClassNames={editStyles.pmEdit}
      testClass={testClass}
      errors={errors}
    />
  );
};

export const TextFieldGlimmer = () => {
  return (
    <TextFieldGlimmerComponent
      editClassNames={editStyles.pmEdit}
      glimmerClassNames={classNames(
        glimmerStyles.textField,
        glimmerStyles.glimmerElement
      )}
    />
  );
};

export default Text;
